import { useQuery } from '@tanstack/react-query';

import { recognitionServices } from '@hero/services';

export const useGetRecognitionAcceptanceRate = ({ recognitionCode }) =>
  useQuery(
    ['recognitionAcceptanceRate', recognitionCode],
    () => recognitionServices.acceptanceRate(recognitionCode),
    {
      enabled: !!recognitionCode
    }
  );
